import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { fontFamilySans, weight } from "@clockwise/web-commons/src/styles/type.styles";
import { theme, greys } from "@clockwise/web-commons/src/styles/color.styles";

const textFieldContainer: CSSProperties = {
  display: "flex",
  flexDirection: "row",
  alignItems: "baseline",
  justifyContent: "space-between",
};

const textField: CSSProperties = {
  width: 300,
};

const empty: CSSProperties = {
  color: theme.textSecondary,
  padding: "12px 0",
};

const mixedOrgCallout = {
  fontSize: 12,
  color: greys.slate,
  fontWeight: weight.std,
  fontFamily: fontFamilySans,
};

export const styles = {
  textFieldContainer,
  textField,
  empty,
  mixedOrgCallout,
};
